import instObj from '@/backend/axios-instances'

const resource = "/bom"
const instance = instObj.baseInstance

export default {
  get(bomId, parameters) {
    return instance.get(`${resource}/${bomId}`, { params: parameters });
  },
  put(bomId, data, parameters) {
    // need project_id as a parameter
    return instance.put(`${resource}/${bomId}`, data, { params: parameters });
  },
  delete(bomId) {
    return instance.delete(`${resource}/${bomId}`);
  }
}
